import SearchInput from './SearchInput';

export default SearchInput;

export type SearchInputProps = {
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  stylesInput?: React.CSSProperties;
  stylesContainer?: React.CSSProperties;
  loading?: boolean;
  mdScreen?: boolean;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};
